import { css } from '@emotion/css';

export const linkStyles = css`
  width: fit-content;
  margin-top: 2rem !important;
`;
